import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

export const PipelineStagesModelSchema = z
  .object({
    id: z.string(),
    name: z.string().nullish(),
    type: z.string().nullish(),
    colour: z.string().nullish(),
    sequence: z.number().nullish(),
    decision_status: z.string().nullish()
  })
  .strict()

export const PipelineStagesModelFields = makeFieldKeys(PipelineStagesModelSchema)

export type PipelineStagesModel = z.infer<typeof PipelineStagesModelSchema>

function validatePipelineStagesModel(
  data: unknown,
  options?: { isArray?: boolean }
): PipelineStagesModel | PipelineStagesModel[] {
  try {
    return validateWithZodSchema(PipelineStagesModelSchema, data, 'pipeline stages model', options) as
      | PipelineStagesModel
      | PipelineStagesModel[]
  } catch (error) {
    throw new Error(`Pipeline stages model validation failed: ${error}`)
  }
}
